export default __webpack_public_path__ + "49e9a534f161779fc51b108e682fd641.png";